/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * gateway
	 * Javascript for the Sign-in / Register gateway specifically
	 * (NOT FOR REGULAR SIGN-IN / REGISTER PAGES, see LC.signin / LC.register)
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "gateway", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {



		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.$tabs = $("#generic-gateway-tabs");
			_this.$register = $(".sign-in-form__not-registered > a");
			_this.$signin = $(".register-form_already-registered > a");

		};

		ex.toggleRegister = function(e) {

			e.preventDefault();
			_this.$tabs.foundation( "selectTab", "#tab-register" );

		};

		ex.toggleSignIn = function(e) {

			e.preventDefault();
			_this.$tabs.foundation( "selectTab", "#tab-signin" );

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {

			_this.$register.on( "click", ex.toggleRegister );
			_this.$signin.on( "click", ex.toggleSignIn );

		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {



		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=gateway.js
